const arrayToObject = (arr:any[], keyField:string) => {
    return Object.assign({}, ...arr.map(item => ({[item[keyField]]: item})));
};

export default arrayToObject;